import { getConfig } from "@jti/fe-common";
import { getIsEvo } from "../../utils";
import { AvpApiEvo } from "./AvpApiEvo";
import { AvpAPILegacy } from "./AvpApiLegacy";
/**
 * AVP - Age Verification Proxy
 */
export class AvpAPI {
    static init() {
        const config = getConfig();
        if (getIsEvo(config.AVP_URL)) {
            return new AvpApiEvo(config.AVP_URL, config.AVP_X_DES_AK_TENANT_TOKEN, config["X-RECAPTCHA-ID"], config.ISO_COUNTRY_CODE);
        }
        return new AvpAPILegacy(config.AVP_URL, config.AVP_X_DES_AK_TENANT_TOKEN, config.ISO_COUNTRY_CODE);
    }
}
//# sourceMappingURL=AvpApi.js.map